import { DynamicControl } from '@shared/models/dynamic-form-control.model';

export class AutocompleteControl extends DynamicControl<string> {
    controlType = 'autocomplete';
    type: 'string';
    valueOptions: Array<string> = [];

    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.valueOptions = options['valueOptions'] || '';
    }
}
